import React from 'react';
import * as BuilderUI from '../BuilderUI';
import BreakdownGroups from './BreakdownGroups';
import Segments from './Segments';
import BreakdownSettings from './BreakdownSettings';
import SectionHeading from '../../SectionHeading';

interface IProps {
  showOverall?: boolean;
  enableAddGroups?: boolean;
  enableAddSegments?: boolean;
}

const Breakdown = ({
  showOverall = true,
  enableAddGroups = true,
  enableAddSegments = true,
}: IProps) => {
  return (
    <BuilderUI.SectionColumn>
      <SectionHeading
        heading="Group By"
        tooltipOption={{
          content: 'Group or Segment data into different categories.',
        }}
      >
        <BreakdownSettings showOverall={showOverall} />
      </SectionHeading>
      <BreakdownGroups enableAddGroups={enableAddGroups} />
      <Segments enableAddSegments={enableAddSegments} />
    </BuilderUI.SectionColumn>
  );
};

export default Breakdown;
